import React from 'react';

export const BotonesSuperiorPresupuestos = (props) => {
	/* Destructuring the props object. */
	const {
		TipoNotificaciones,
		setTipoNotificaciones,
		cambioNotificaciones,
		NumPresupuestos,
		FiltroNombre,
		setFiltroNombre,
		getPresupuestos,
		NumerServicios,
	} = props;

	return (
		<>
			<div className='HeadPresupuesto'>
				<div className='superiorHeadContentPresupuestos'>
					<div className='centrador derSuperiorHeadContentPresupuestos'>
						<div>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='40'
								height='40'
								fill='currentColor'
								className='bi bi-card-checklist'
								viewBox='0 0 16 16'
							>
								<path d='M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z' />
								<path d='M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z' />
							</svg>
						</div>
						<div className='centrador titleHeadHistorialFacturas'>
							<b>Agenda</b>
						</div>
					</div>
					<div className='centrador izqSuperiorHeadContentPresupuestos'>
						<input
							className='inputTextUsuario'
							type='text'
							placeholder='Nombre Usuario'
							value={FiltroNombre}
							onChange={(event) => setFiltroNombre(event.target.value)}
						/>
					</div>
				</div>
				<div className='separador'></div>

				<div className='menuPresupuestos BotonesSuperiorPresupuestos'>
					<div
						className={TipoNotificaciones[0]}
						onClick={() => {
							cambioNotificaciones(0);
						}}
					>
						<div className='centrador'>{'Hoy (' + NumerServicios.hoy + ')'}</div>
					</div>

					<div
						className={TipoNotificaciones[1]}
						onClick={() => {
							cambioNotificaciones(1);
						}}
					>
						<div className='centrador'>
							{'Activos (' + NumerServicios.pendientes + ')'}
						</div>
					</div>

					<div
						className={TipoNotificaciones[2]}
						onClick={() => {
							cambioNotificaciones(2);
						}}
					>
						<div className='centrador'>
							{'Pendientes (' + NumerServicios.porConfirmar + ')'}
						</div>
					</div>

					<div
						className={TipoNotificaciones[3]}
						onClick={() => {
							cambioNotificaciones(3);
						}}
					>
						<div className='centrador'>
							{'Completados (' + NumerServicios.completados + ')'}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
